<template>
    <div class="batch-house">
        <alart-msg :display="error.status" styleType="error" @alartStatus="error.status = false">
            <span class="title" slot="title">{{error.msg}}</span>
        </alart-msg>
        <div class="tool-bar-mask"></div>
        <div class="batch-house-head">
            <h1 class="page-title">批次新增</h1>
            <div class="btn-group" :class="{'fixed-save': batchList.length > 0}">
                <a @click="$analytics.logEvent('下載批次Excel檔案', { screen_name: '下載批次Excel檔案'})" href="https://flypig-public.s3.ap-southeast-1.amazonaws.com/doc/batch_upload_v1.0.7.xlsx">
                    <button class="batch-button download">
                        <img src="@/assets/img/icon/download_gray.svg" alt="">
                        檔案下載
                    </button>
                </a>
                <button v-if="batchList.length > 0"  @click="saveBatch" class="default-button save">確認新增</button>
                <button v-else class="batch-button upload" @click="uploadFile(), $analytics.logEvent('上傳批次Excel檔案', { screen_name: '上傳批次Excel檔案'})">
                    <img src="@/assets/img/icon/file_gray.svg" alt="">
                    上傳檔案
                    <input type="file" id="avatar" ref="upload" name="avatar">
                </button>
            </div>
        </div>
        <faq-block>
            <div class="faq-title" slot="faq-title">
                <img src="@/assets/img/icon/info_gray.svg" alt="">
                流程說明：
            </div>
            <div class="faq-body" slot="faq-body">
                <ul>
                    <li>1. 下載範例excel</li>
                    <li>2. 依照excel說明，填入房源訊息</li>
                    <li>3. 上傳excel</li>
                    <li>4. 更新房源圖片</li>
                    <li class="li-alarm">注意：上傳的第一張圖片會預設為封面，可再編輯封面圖片</li>
                </ul>
            </div>
        </faq-block>
        <span v-if="batchErrList.length > 0" class="err-count">{{batchErrList.length}} 筆資料上傳失敗</span>
         <ul v-if="batchErrList.length > 0" class="err">
            <li v-for="(house, index) in batchErrList" :key="index" >
                <div class="house-item-head">
                    <span class="order">{{index+1}}</span>
                    <span class="name">{{house.name}}</span>
                    <span class="address">{{house.address}}</span>
                </div>
                <upload-batch-img :houseIndex="index"></upload-batch-img>
            </li>
        </ul>
        <ul v-else>
            <li v-for="(house, index) in batchList" :key="index" >
                <div class="house-item-head">
                    <span class="order">{{index+1}}</span>
                    <span class="name">{{house.name}}</span>
                    <span class="address">{{house.address}}</span>
                </div>
                <upload-batch-img :houseIndex="index"></upload-batch-img>
            </li>
        </ul>
    </div>
</template>
<script>
import XLSX from "xlsx";
import FileUpload from 'vue-upload-component';
import uploadBatchImg from '@/components/landlord/houseStatus/houseManagement/batchHouse/uploadBatchImg.vue';
import FaqBlock from '@/components/landlord/faq/FaqBlock.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'

export default {
     data () {
        return {
            houseExcel: null,
            houseBatchInfo: [],
            files: [],
            uploadImagesCount: 0
        }
    },
    mounted () {
        this.$analytics.logEvent('批次新增', { screen_name: '批次新增'})
        this.$refs.upload.addEventListener("change", e => {
            this.uploadExcel(e);
        });
    },
    destroyed () {
        this.$store.commit('batchUpload/set_default')
    },
    methods: {
        uploadExcel: function (e) {
            this.$store.dispatch('uploadBatch', e)
            .then( () => {
                this.readExcel(e)
            })
        },
        uploadFile: function () {
            document.getElementById("avatar").click()
        },
        saveBatch: function () {
            this.$router.push({ name: 'HouseManagementDefault', query: { success: '1' }})
            // this.$store.dispatch('setImageCount').then(()=>{
            //     if(this.batchErrList.length > 0){
            //         this.$store.dispatch('saveErrBatch')
            //         .then((val)=>{
            //             if(val == 'done'){
            //                 this.$router.push({ name: 'HouseManagementDefault', query: { success: '1' }})
            //             }
            //         })
            //     }else{
            //         this.$store.dispatch('saveBatch')
            //         .then((val)=>{
            //             if(val == 'done'){
            //                 this.$router.push({ name: 'HouseManagementDefault', query: { success: '1' }})
            //             }else{
                            
            //             }
            //         })
            //     }
            // })
            // this.uploadImages.map((image) => {
            //     if(image.length > 0){
            //         this.uploadImagesCount++
            //     }
            // })
            // console.log(this.uploadImagesCount)
            // if(this.batchErrList.length > 0){
            //     this.$store.dispatch('saveErrBatch')
            // }else{
            //     this.$store.dispatch('saveBatch')
            // }
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                // console.log('response', newFile.response)
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
                return prevent()
                }
            }
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        readExcel: function(e) {
            var _self = this
            const files = e.target.files
            const fileReader = new FileReader()

            fileReader.onload = ev =>{
                try{
                    _self.dsActors = []
                    const data = ev.target.result
                    const workbook = XLSX.read(data, {
                        type: "binary"
                    })
                    var sheet_name_list = workbook.SheetNames
                    const ws = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheet_name_list[0]],
                        { header: 1 }
                    )
                    this.$store.dispatch('setBatchExcle' , ws)
                }catch (e) {
                    return false;
                }
            }
            fileReader.readAsBinaryString(files[0]);
        },
        // getHouseName: function (val) {
        //     if(val){
        //         return val
        //     }else{
        //         return '未填寫房源'
        //     }
        // },
        // getLane: function (val) {
        //     if(val){
        //         return val+'巷'
        //     }else{
        //         return ''
        //     }
        // },
        // getAlley: function (val) {
        //     if(val){
        //         return val+'弄'
        //     }else{
        //         return ''
        //     }
        // },
        // getNumber: function (val) {
        //     if(val){
        //         return val+'號'
        //     }else{
        //         return ''
        //     }
        // },
        // getDash: function (val) {
        //     if(val){
        //         return '之'+val
        //     }else{
        //         return ''
        //     }
        // },
        // getFloor: function (val) {
        //     if(val){
        //         return ','+val+'樓'
        //     }else{
        //         return ''
        //     }
        // },
        // getRoom: function (val) {
        //     if(val){
        //         return '之'+val
        //     }else{
        //         return ''
        //     }
        // }
    },
    computed: {
        ...mapGetters({
            batchList: 'GET_BATCH_LIST',
            batchErrList: 'GET_BATCH_ERROR_LIST',
            error: 'GET_BATCH_FAIL'
            // uploadImages: 'GET_UPLOAD_IMAGES'
        })
    },
    components:{
        FileUpload,
        uploadBatchImg,
        FaqBlock,
        AlartMsg
    }
}
</script>
<style lang="scss" scoped>
    .batch-house{
        .batch-house-head{
            position: relative;
            margin-top: 20px;
            margin-bottom: 40px;
            display: flex;
            align-items: center;
            .btn-group{
                position: absolute;
                display: flex;
                right: 20px;
                .batch-button{
                    width: 120px;
                    height: 44px;
                    border-radius: 4px;
                    border: solid 1px #e3e4e3;
                    background-color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    >img{
                        margin-right: 4px;
                    }
                    #avatar{
                        display: none;
                    }
                }
                .download{
                    margin-right: 12px;
                }
                .save{
                    width: 200px;
                    height: 42px;
                }
            }
        }
        .faq-title{
            display: flex;
            line-height: 1.38;
            margin-bottom: -4px;
            img{
                margin-right: 4px;
            }
        }
        .faq-body{
            ul{
                >li{
                    font-weight: 300;
                    margin-bottom: 12px;
                }
                >li.li-alarm{
                    color: #fc7171;
                }
            }
        }
        .err-count{
            display: block;
            margin-bottom: 24px;
            font-size: 20px;
            font-weight: 500;
            color: #fc7171;
        }
        >ul{
            >li{
                position: relative;
                width: 1114px;
                // height: 150px;
                border-radius: 10px;
                border: solid 1px #f0f0f0;
                background-color: #ffffff;
                padding: 20px;
                margin-bottom: 24px;
                .house-item-head{
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-bottom: 4px;
                    .order{
                        color: #ff9275;
                        font-weight: 300;
                    }
                    .name{
                        font-size: 20px;
                        margin: 0 12px;
                    }
                    .address{
                        font-weight: 300;
                    }
                }
            }
        }
    }
    .batch-house.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            border-bottom: 1px solid #f0f0f0;
            margin-left: -39px;
        }
        .batch-house-head{
            position: relative;
            margin-top: 22px;
            margin-bottom: 40px;
            h1{
                position: fixed;
                top: 26px;
            }
            .btn-group{
                position: fixed;
                top: 19px;
                right: unset;
                margin-left: 903px;
            }
            .btn-group.fixed-save{
                margin-left: 822px;
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .batch-house{
            >ul{
                >li{
                    width: 1101px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/batchHouse/BatchHouse.vue